import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { canActivate as RouteGuardService } from './guard/route-guard.service';
import { canActivate as MonitorGuardService } from './guard/monitor.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'redirect',
    pathMatch: 'full',
  },
  {
    path: 'redirect',
    loadChildren: () => import('./redirect/redirect.module').then( m => m.RedirectPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'prenotazioni',
    data: {
      roles: ['websi3.prenota']
    },
    loadChildren: () => import('./prenotazioni/prenotazioni.module').then( m => m.PrenotazioniPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'agenda',
    data: {
      roles: ['websi3.agenda']
    },
    loadChildren: () => import('./agenda/agenda.module').then( m => m.AgendaPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'sportello',
    data: {
      roles: ['websi3.sportello']
    },
    loadChildren: () => import('./sportello/sportello.module').then( m => m.SportelloPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'device',
    data: {
      roles: ['websi3.superadmin']
    },
    loadChildren: () => import('./monitor/monitor.module').then( m => m.MonitorPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'statistiche',
    data: {
      roles: ['websi3.statistiche']
    },
    loadChildren: () => import('./statistiche/statistiche.module').then( m => m.StatistichePageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'sedi',
    data: {
      roles: ['websi3.configura', 'websi3.adminsede']
    },
    loadChildren: () => import('./sedi/sedi.module').then( m => m.SediPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'utenti',
    data: {
      roles: ['websi3.gestoreutenti']
    },
    loadChildren: () => import('./utenti/utenti.module').then( m => m.UtentiPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'monitoraggio',
    data: {
      roles: ['websi3.monitoraggio']
    },
    loadChildren: () => import('./monitoraggio/monitoraggio.module').then( m => m.MonitoraggioPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'multimedia',
    data: {
      roles: ['websi3.multimedia']
    },
    loadChildren: () => import('./multimedia/multimedia.module').then( m => m.MultimediaPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'import-prenotazioni',
    data: {
      roles: ['websi3.superadmin', 'websi3.importprenotazioni']
    },
    loadChildren: () => import('./import-prenotazioni/import-prenotazioni.module').then( m => m.ImportPrenotazioniPageModule),
    canActivate: RouteGuardService
  },
  {
    path: 'satisfaction',
    data: {
      roles: ['websi3.superadmin', 'websi3.configura', 'websi3.satisfaction']
    },
    loadChildren: () => import('./satisfaction/satisfaction.module').then( m => m.SatisfactionPageModule)
  },
  {
    path: 'conf-privacy-policy',
    data: {
      roles: ['websi3.configura']
    },
    loadChildren: () => import('./conf-privacy-policy/conf-privacy-policy.module').then( m => m.ConfPrivacyPolicyPageModule),
    canActivate: RouteGuardService
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
